import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IconButton, Button, Grid, ListItemSecondaryAction, TextField, Box } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { isMobile } from 'react-device-detect';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector } from 'react-redux';
import { Create, Person } from '@material-ui/icons';
//import { history } from '../../helpers/history';


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: "470px",
        overflowY: "auto",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    inlinenew: {
        display: 'inline',
        color: '#014587'
    },
    styleaccordion: {
        borderLeft: '3px solid #014587',
        // backgroundColor : "#5A5759",
        color: "black",
        minWidth: "100%",
        width: `100%`,
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `30px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `50%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `50%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `50%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `50%`,
        },
    },
    icon: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '20%'
        },
        [theme.breakpoints.up('sm')]: {
            width: `20%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `24%`,
        },
    },
    listItems: {
        [theme.breakpoints.up('xs')]: {
            color: 'white',
            fontSize: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('md')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            color: 'white',
            fontSize: '100%'
        },
    },
    Items: {
        [theme.breakpoints.up('xs')]: {
            color: 'white',
            width: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            color: 'white',
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            color: 'white',
            width: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            color: 'white',
            width: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            color: 'white',
            width: '100%'
        },
    },
    LogoImg: {
        [theme.breakpoints.up('xs')]: {
            width: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            width: '50%'
        },
        [theme.breakpoints.up('xl')]: {
            width: '50%'
        },
    },
    logoaccordion: {
        textAlign: "rigth"
    },
    imgLogo: {
        height: '40%'
    },
    styledialog: {
        maxWidth: "100%",
        maxHeight: "80%",
        width: "100%",
        height: "80vh"
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
    buttonDelete: {
        color: '#fff',
        backgroundColor: '#2E2757',
        marginRight: '10px',
        '&:hover': {
            backgroundColor: "#29581c",
        },
    },
    buttonEdit: {
        color: '#fff',
        backgroundColor: '#2E2757',
        '&:hover': {
            backgroundColor: "#706D85",
        },
    },
    popper: {
        position: 'relative',
        width: '100% !important',
        /*[theme.breakpoints.up('xs')]: {
            paddingLeft: 10,
            paddingRight: 10
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: 20,
            paddingRight: 20
        },*/
    },
}));

const BeneficiaryList = ({ onCloseDialogBeneficiaryList, openDialogBeneficiaryList, beneficiaries,
    getBeneficiarySelected, openDialogBeneficiaryForm, editBeneficiary, deleteBeneficiary, handleConvertMask,
    handleChangeOpenAccordionInternal, handleChangeOpenAccordionExternal, openAccordionInternal, openAccordionExternal, typeBeneficiaries }) => {
    // console.log('beneficiaries own', beneficiaries)
    const classes = useStyles();
    const permissions = useSelector(state => state.permissions)
    const [bnSelected, setBnSelected] = React.useState(beneficiaries[0])



    const sendBeneficiarySelected = (data) => {
        getBeneficiarySelected(data)
        setBnSelected(data)
    }

    const sendEditBeneficiarySelecter = (data) => {
        editBeneficiary(data)
    }

    /* const renderTitleTabs = (urlicon, title) => {
      return <List>
                  <ListItem key={1} className = {classes.Items}>
                      <ListItemAvatar>
                          <Avatar src = {urlicon} variant="square"  className={classes.imgLogo} />
                      </ListItemAvatar>
                      <ListItemText primary={ <Typography className = {classes.listItems}> { title }</Typography> }  />
                  </ListItem>
              </List>
  } */

    return (
        <Dialog
            // fullScreen
            open={openDialogBeneficiaryList}
            onClose={onCloseDialogBeneficiaryList}
            maxWidth='sm'
            // disableBackdropClick
            // disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="simple-dialog-title"> {'Seleccionar Beneficiario '}</DialogTitle>
            {/* <AppBar >
                <Toolbar style={{ position: 'relative', backgroundColor: "#2E2757" }}>
                    <IconButton edge="start" color="inherit" onClick={onCloseDialogBeneficiaryList} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" style={{ flex: 1 }}>
                        {'Seleccionar Beneficiario '}
                    </Typography>
                </Toolbar>
            </AppBar> */}
            <br />
            {
                (typeBeneficiaries === "INTERNO") ?
                    <>
                        {renderBeneficiaryList(beneficiaries.filter(b => {
                            return b.beneficiary === 'INTERNO'
                        }), classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, "INTERNO", handleConvertMask, onCloseDialogBeneficiaryList, bnSelected, permissions)}
                    </>
                    :
                    (typeBeneficiaries === "EXTERNO") ?
                        <>
                            {renderBeneficiaryList(beneficiaries.filter(b => {
                                return ((b.beneficiary === 'EXTERNO') && (b.type_name !== "TARJETA DE CREDITO"))
                            }), classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, "OTRAS INSTITUCIONES", handleConvertMask, onCloseDialogBeneficiaryList, bnSelected, permissions)}
                        </> :
                        (typeBeneficiaries === "TARJETAS DE CREDITO") ?
                            <>
                                {renderBeneficiaryList(beneficiaries.filter(b => {
                                    return ((b.beneficiary === 'EXTERNO') && (b.type_name === "TARJETA DE CREDITO"))
                                }), classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, "OTRAS INSTITUCIONES", handleConvertMask, onCloseDialogBeneficiaryList, bnSelected, permissions)}
                            </> :
                            <>
                                {renderBeneficiaryList(beneficiaries.filter(b => {
                                    return b.beneficiary === 'PROPIA' && b.type_name !== "CERTIFICADOS"
                                }), classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, "PROPIA", handleConvertMask, onCloseDialogBeneficiaryList)}
                            </>
            }

            <br />
        </Dialog>

    );
}

const renderBeneficiaryList = (beneficiaries, classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, typebeneficiary, handleConvertMask, onCloseDialogBeneficiaryList, bnSelected, permissions) => {
    if (beneficiaries.length > 0) {
        return <Grid container style={{ padding: "0 15px" }}>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <List className={classes.root}>
                    <Autocomplete
                        id={"beneficiryListAutocomplete"}
                        classes={{ popper: classes.popper }}
                        open={true}
                        disablePortal={true}
                        selectOnFocus={true}
                        value={bnSelected || null}
                        options={beneficiaries}
                        // onChange={(e, nv) => {
                        //     sendBeneficiarySelected(nv)
                        // }}
                        disableClearable
                        getOptionLabel={(option) => `${option.alias} - ${option.name}`}
                        renderOption={(row, i) => (
                            <div key={row.id} style={{ width: "100%" }}>
                                <Grid item xs={12} /* md={12} lg={12} xl={12} */ container>
                                    <Grid item xs={12} md={12} lg={12} xl={12}>
                                        <ListItem button alignItems="center">
                                            <ListItemAvatar>
                                                <Person color='primary' />
                                            </ListItemAvatar>
                                              <Box style={{ flex: 1, minWidth: 0, marginRight: 18 }}>
                                            <ListItemText style={{ paddingRight: (isMobile ? ((typebeneficiary === "OTRAS INSTITUCIONES") ? '70px' : ((typebeneficiary === "PROPIA") ? '0px' : '50px')) : '0px') }}
                                                primary={(typebeneficiary !== "PROPIA") ? row.name : row.alias}
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography
                                                            component="span"
                                                            variant="body2"
                                                            className={classes.inline}
                                                            color="textPrimary"
                                                        >
                                                            {row.type_name + " - " + row.name_institution}
                                                        </Typography>
                                                        {` — ${handleConvertMask(row.number)}`}
                                                    </React.Fragment>
                                                }
                                                onClick={() => sendBeneficiarySelected(row)}
                                            />
                                            </Box>
                                            {/* { (typebeneficiary !== "PROPIA") && <ListItemSecondaryAction> */}
                                            {/* {(typebeneficiary !== "PROPIA") ?
                                        <IconButton edge="end" style={{ padding: '5px', marginRight: '10%' }} aria-label="delete" onClick={() => deleteBeneficiary(row)} >
                                            <img src={process.env.PUBLIC_URL + '/images/borrar.png'} alt="Logo" style={{ width: '40px' }} />
                                        </IconButton> :
                                        ''} */}

                                            {/* <IconButton edge="end" aria-label="delete" onClick = {() => sendEditBeneficiarySelecter(row) } >
                                                            <Icon>create</Icon>
                                                        </IconButton>


                                                </ListItemSecondaryAction>} */}
                                            <ListItemSecondaryAction>
                                                {(typebeneficiary !== "PROPIA") ?
                                                    <>
                                                      <Box style={{ display: 'flex', alignItems: 'flex-start', gap: '4px'}}>
                                                        {permissions.includes(4) && <IconButton edge="end" aria-label="delete" /* fontSize="large" */
                                                            /* style={{ color: '#fff', backgroundColor: '#2E2757', marginRight: '10px' }}  */
                                                            onClick={() => deleteBeneficiary(row)} >
                                                            <DeleteIcon style={{ fontSize: '30px', color: 'red' }} />
                                                        </IconButton>}
                                                        {(typebeneficiary === "OTRAS INSTITUCIONES") ?
                                                            <IconButton edge="end" aria-label="edit"
                                                                /* style={{ color: '#fff', backgroundColor: '#2E2757', fontSize: 10, '&.MuiIconButtonRoot:hover': {
                                                                    backgroundColor: "#706D85",
                                                                }, }}  */
                                                                onClick={() => sendEditBeneficiarySelecter(row)} >
                                                                <Create color='primary' style={{ fontSize: '30px' }}/>
                                                            </IconButton>
                                                            :
                                                            ''}
                                                            </Box>
                                                    </>
                                                    :
                                                    ''}
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    </Grid>
                                    {/* <Grid item xs={2} md={2} lg={2} xl={2} container alignItems='center'>
                                        {(typebeneficiary !== "PROPIA") ?
                                            <IconButton edge="end" style={{ padding: '5px', marginRight: '10%' }} aria-label="delete" onClick={() => deleteBeneficiary(row)} >
                                                <img src={process.env.PUBLIC_URL + '/images/borrar.png'} alt="Logo" style={{ width: '40px' }} />
                                            </IconButton> :
                                            ''}
                                    </Grid> */}
                                </Grid>
                                <Divider variant="inset" component="li" />
                            </div>
                        )}
                        renderInput={(params) => <TextField {...params}
                            label="Buscar un beneficiario"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: null,
                            }}
                        />}
                    />

                </List>
            </Grid>
            {(typebeneficiary !== "PROPIA") &&
                <Grid container spacing={1} justifyContent='center'>
                    {permissions.includes(3) && <Grid item xs={12} sm={12} md={4} >
                        <Button color='primary' variant="contained" fullWidth onClick={() => openDialogBeneficiaryForm()}>{"AGREGAR"}</Button>
                    </Grid>}
                    <Grid item xs={12} sm={12} md={4} >
                        <Button color='primary' variant="outlined" fullWidth onClick={onCloseDialogBeneficiaryList}>{"CANCELAR"}</Button>
                    </Grid>
                </Grid>
            }
        </Grid>
    } else {
        return <Grid container style={{ padding: "0 15px" }}>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <List className={classes.root}>
                    <ListItem button alignItems="flex-start" >
                        <ListItemText
                            primary={(typebeneficiary !== "PROPIA") ? '(No existen Beneficiarios)' : '(No existen Cuentas Propias)'}
                        />
                    </ListItem>
                </List>
            </Grid>
            {(typebeneficiary !== "PROPIA") &&
                <Grid container spacing={1} justifyContent='center'>
                    {permissions.includes(3) && <Grid item xs={12} sm={12} md={4} >
                        <Button color='primary' variant="contained" fullWidth onClick={() => openDialogBeneficiaryForm()}>{"AGREGAR"}</Button>
                    </Grid>}
                    <Grid item xs={12} sm={12} md={4} >
                        <Button color='primary' variant="outlined" fullWidth onClick={onCloseDialogBeneficiaryList}>{"CANCELAR"}</Button>
                    </Grid>
                </Grid>
            }
        </Grid>
    }

}

export default BeneficiaryList
